/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_List_Subtitle1Inputs */

const vi_cmspage_list_subtitle1 = /** @type {(inputs: Cmspage_List_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang tĩnh website (giới thiệu, chính sách, liên hệ…) và câu chuyện sản phẩm gắn vào nhóm sản phẩm.`)
};

/**

* @param {Cmspage_List_Subtitle1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_list_subtitle1 = /** @type {((inputs?: Cmspage_List_Subtitle1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_List_Subtitle1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_list_subtitle1(inputs)
});
export { cmspage_list_subtitle1 as "cmsPage_list_subtitle" }